"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var tabs_1 = require("@reach/tabs");

var polished_1 = require("polished");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var labelOne = ui_blocks_1.TYPOGRAPHY.labelOne;
var isClickable = ui_blocks_1.INTERACTIVE.isClickable,
    isDisabled = ui_blocks_1.INTERACTIVE.isDisabled;
var mainAsideStyling = styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: 0;\n\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:disabled {\n    ", "\n  }\n\n  &[data-selected] {\n    color: ", ";\n    font-weight: ", ";\n  }\n"], ["\n  padding: 0;\n\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:disabled {\n    ", "\n  }\n\n  &[data-selected] {\n    color: ", ";\n    font-weight: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('COLOR.GREY.MEDIUM', theme);
}, function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('COLOR.GREY.DARK', theme);
}, isDisabled, function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('COLOR.GREY.DARK', theme);
}, function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('TYPOGRAPHY.TEXT.BOLD', theme);
});
var scheduleStyling = styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  text-align: left;\n  border: ", " solid\n    ", ";\n  border-radius: ", ";\n  padding: 1rem;\n  white-space: nowrap;\n\n  transition: all 0.25s cubic-bezier(0.66, 0.22, 0.44, 0.82);\n\n  &:hover {\n    background: transparent;\n  }\n\n  &[data-selected] {\n    color: inherit;\n    font-weight: inherit;\n    background: ", ";\n    border: ", " solid\n      ", ";\n  }\n\n  p {\n    margin-bottom: 0;\n    line-height: 1rem;\n  }\n"], ["\n  text-align: left;\n  border: ", " solid\n    ", ";\n  border-radius: ", ";\n  padding: 1rem;\n  white-space: nowrap;\n\n  transition: all 0.25s cubic-bezier(0.66, 0.22, 0.44, 0.82);\n\n  &:hover {\n    background: transparent;\n  }\n\n  &[data-selected] {\n    color: inherit;\n    font-weight: inherit;\n    background: ", ";\n    border: ", " solid\n      ", ";\n  }\n\n  p {\n    margin-bottom: 0;\n    line-height: 1rem;\n  }\n"])), polished_1.rem(1), function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('COLOR.GREY.200', theme);
}, function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('LINE.RADIUS.MEDIUM', theme);
}, function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('COLOR.BLUE.100', theme);
}, polished_1.rem(1), function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('COLOR.BLUE.300', theme);
});
var nestedStyling = styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  padding: 0;\n\n  color: ", ";\n\n  border-radius: 1.625rem;\n\n  transition: ", ";\n\n  overflow: hidden;\n\n  text-overflow: ellipsis;\n\n  white-space: nowrap;\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:disabled {\n    ", "\n  }\n\n  &[data-selected] {\n    background: none;\n    color: ", ";\n    font-weight: ", ";\n  }\n"], ["\n  padding: 0;\n\n  color: ", ";\n\n  border-radius: 1.625rem;\n\n  transition: ", ";\n\n  overflow: hidden;\n\n  text-overflow: ellipsis;\n\n  white-space: nowrap;\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:disabled {\n    ", "\n  }\n\n  &[data-selected] {\n    background: none;\n    color: ", ";\n    font-weight: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('COLOR.GREY.MEDIUM', theme);
}, function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('MOTION.DEFAULT_TRANSITION', theme);
}, function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('COLOR.GREY.DARK', theme);
}, isDisabled, function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('COLOR.UTILITY.ACTION', theme);
}, function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('TYPOGRAPHY.TEXT.BOLD', theme);
});
var patternStyles = {
  main: mainAsideStyling,
  aside: mainAsideStyling,
  schedule: scheduleStyling,
  nested: nestedStyling
};
exports.Tab = styled_components_1.default(tabs_1.Tab)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n\n  background: transparent;\n\n  ", "\n"], ["\n  ", "\n  ", "\n\n  background: transparent;\n\n  ", "\n"])), labelOne, isClickable, function (props) {
  return ui_helper_props_to_styles_1.mapStyles(props, 'pattern', patternStyles);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;